// Components
import Box from '../Box/Box';

const Accordion = ({ data, noPadding, loading }) => {
    return (
        <div className="accordion-tool">
            {data.map((item) => (
                <Box
                    collapsible={{
                        open: item.open,
                    }}
                    header={{
                        title: item.title,
                        info: item.info,
                    }}
                    noPadding={noPadding}
                    loading={loading}
                >
                    {item.content}
                </Box>
            ))}
        </div>
    );
};

export default Accordion;
